import { IconProps } from '@/types/icon';

export function IconeCurtir({ size, color, ...props }: IconProps) {
  return (
    <svg
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      {...props}
    >
      <path
        d="M0.0683594 15.6496H3.12796V6.47077H0.0683594V15.6496ZM16.8962 7.23567C16.8962 6.39428 16.2078 5.70587 15.3664 5.70587H10.5399L11.2665 2.21027L11.2895 1.9655C11.2895 1.65189 11.1594 1.36123 10.9529 1.15471L10.1421 0.351562L5.10906 5.39226C4.82604 5.66762 4.65776 6.05007 4.65776 6.47077V14.1198C4.65776 14.9612 5.34617 15.6496 6.18757 15.6496H13.0717C13.7065 15.6496 14.2496 15.2671 14.4791 14.7164L16.7891 9.32385C16.8579 9.14792 16.8962 8.96434 16.8962 8.76547V7.23567Z"
        fill={color}
        fillOpacity="0.95"
      />
    </svg>
  );
}
